// @flow

import { observable, action, runInAction, configure } from 'mobx';
import industriesApi from 'api/industries.api';

configure({ enforceActions: 'observed' });

type OptionsType = Array<{
  filterPosition: number,
  id: string,
  name: string
}>;

const toOptions = (data: OptionsType, label?: string[]): Array<{ value: string, label: string }> => (
  data
    .sort((a, b) => (a.filterPosition && a.filterPosition < b.filterPosition) ? -1 : 1)
    .map(r => ({ value: r.id, label: label ? label.map(n => r[n]).join(', ') : r.name }))
);

class CompanyOptionsStore {
  @observable loading: boolean = true
  @observable options: any = {
    industries: []
  }

  @action.bound
  async fetchOptions() {
    try {
      const { data: industries } = await industriesApi.fetch();

      runInAction(() => {
        this.loading = false;
        this.options = {
          industries: toOptions(industries)
        };
      });
    } catch (error) {
      runInAction(() => {
        this.loading = false;
      });
    }
  }
}

export default new CompanyOptionsStore();
